import { Tooltip } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import React from 'react';
import { HistoryIcon, InfoIcon, DollarIcon, EnvelopeIcon } from '../../../icons';

const DetailsToggleButton = ({
    visibleDetails: { activityInfoShown, transactionShown, historyShown, emailsShown },
    setVisibleDetails
}) => {
    return (
        <ToggleButtonGroup
            exclusive
            size="small"
            style={{
                padding: '8px'
            }}
        >
            <Tooltip title="Show more information about the Activity">
                <ToggleButton
                    value="info"
                    selected={activityInfoShown}
                    onClick={() =>
                        setVisibleDetails(prev => ({
                            ...prev,
                            activityInfoShown: !activityInfoShown
                        }))
                    }
                    style={{
                        padding: '5px'
                    }}
                >
                    <InfoIcon style={{ fontSize: 'medium' }} />
                </ToggleButton>
            </Tooltip>
            <Tooltip title="Show transaction history">
                <ToggleButton
                    value="transactions"
                    selected={transactionShown}
                    onClick={() =>
                        setVisibleDetails(prev => ({
                            ...prev,
                            transactionShown: !transactionShown
                        }))
                    }
                    style={{
                        padding: '5px'
                    }}
                >
                    <DollarIcon style={{ fontSize: 'medium' }} />
                </ToggleButton>
            </Tooltip>
            <Tooltip title="Show related emails">
                <ToggleButton
                    value="emails"
                    selected={emailsShown}
                    onClick={() =>
                        setVisibleDetails(prev => ({
                            ...prev,
                            emailsShown: !emailsShown
                        }))
                    }
                    style={{
                        padding: '5px'
                    }}
                >
                    <EnvelopeIcon style={{ fontSize: 'medium' }} />
                </ToggleButton>
            </Tooltip>
            <Tooltip title="Show booking history">
                <ToggleButton
                    value="history"
                    selected={historyShown}
                    onClick={() =>
                        setVisibleDetails(prev => ({
                            ...prev,
                            historyShown: !historyShown
                        }))
                    }
                    style={{
                        padding: '5px'
                    }}
                >
                    <HistoryIcon style={{ fontSize: 'medium' }} />
                </ToggleButton>
            </Tooltip>
        </ToggleButtonGroup>
    );
};

export default DetailsToggleButton;
